(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-payment-footer.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-payment-footer.js'); 'use strict';

var _svs$maltipset$helper = svs.maltipset.helpers,
    getMarketplaceAccount = _svs$maltipset$helper.getMarketplaceAccount,
    isMarketplaceToggled = _svs$maltipset$helper.isMarketplaceToggled;
svs.maltipset.views.BetslipPaymentFooter = Backbone.Marionette.View.extend({
  ui: {
    payButton: '.js-btn-pay'
  },
  className: 'payment-footer',
  modelEvents: {
    change: 'render',
    'wager:paySuccess wager:payError': 'paymentDone'
  },
  events: {
    'click @ui.payButton': 'onPayClick'
  },
  log: new svs.core.log.Logger('svs.maltipset.views.BetslipPaymentFooter'),
  template: function template(data) {
    return svs.maltipset.templates.betslip_payment_footer(data);
  },
  initialize: function initialize() {
    var currentDraw = this.getCurrentDraw();
    this.drawNumber = currentDraw.get('drawNumber');
    this.productId = currentDraw.get('productId');
    this.onPay = this.onPay.bind(this);
  },
  getCurrentDraw: function getCurrentDraw() {
    return svs.maltipset.collections.draws.models[svs.maltipset.collections.draws.currentDrawIndex];
  },
  handleNewSharesError: function handleNewSharesError(error) {
    this.log.warn('Failed to fetch marketplace group', error);
    this.onPay();
  },
  handleMarketplacePayment: function handleMarketplacePayment(account) {
    var _this = this;

    var _svs$components$marke = svs.components.marketplace.accountSelector.helpers,
        getNewShares = _svs$components$marke.getNewShares,
        showIncreaseWarning = _svs$components$marke.showIncreaseWarning;

    if (new Date(account.buyinCloseTime).getTime() < Date.now()) {
      return this.onPay();
    }

    getNewShares({
      drawNumber: this.drawNumber,
      productId: this.productId
    }, function (error, newAccount) {
      if (error) return _this.handleNewSharesError(error);

      if (newAccount.newShares > 0) {
        showIncreaseWarning(newAccount.newShares, svs.utils.format.Currency(newAccount.newBalance), _this.onPay);
      } else {
        _this.onPay();
      }
    });
  },
  onPay: function onPay() {
    var _this2 = this;

    window.requestIdleCallback(function () {
      _this2.model.pay();
    });
  },
  handlePayment: function handlePayment() {
    var marketplaceAccount = isMarketplaceToggled() && getMarketplaceAccount();

    if (marketplaceAccount) {
      this.handleMarketplacePayment(marketplaceAccount);
    } else {
      this.onPay();
    }
  },
  onPayClick: function onPayClick() {
    this.handlePayment();
  },
  paymentDone: function paymentDone() {},
  onAccountSelectorDataChange: function onAccountSelectorDataChange(_ref) {
    var currentAccount = _ref.currentAccount;
    var balance = currentAccount ? currentAccount.balance.toString() : this.model.get('userAccountBalance');
    this.model.setAccountBalance(balance);
  },
  renderAccountSelector: function renderAccountSelector() {
    if (svs.components.marketplace && svs.components.marketplace.accountSelector && $('.account-change-holder').length > 0) {
      svs.components.marketplace.accountSelector.render('account-change-holder');
    }
  },
  onDestroy: function onDestroy() {
    if (svs.components.marketplace && svs.components.marketplace.accountSelector) {
      svs.components.marketplace.accountSelector.helpers.observer.unsubscribe(this.onAccountSelectorDataChange);
    }
  },
  onAttach: function onAttach() {
    if (svs.components.marketplace && svs.components.marketplace.accountSelector) {
      svs.components.marketplace.accountSelector.helpers.observer.notify({
        drawNumber: this.drawNumber,
        productId: this.productId,
        userAccountBalance: this.model.get('userAccountBalance') ? this.model.get('userAccountBalance').toString() : '0'
      });
      this.onAccountSelectorDataChange = this.onAccountSelectorDataChange.bind(this);
      svs.components.marketplace.accountSelector.helpers.observer.subscribe(this.onAccountSelectorDataChange, {
        emitCurrentValue: true
      });
      this.renderAccountSelector();
    }
  },
  onDomRefresh: function onDomRefresh() {
    this.renderAccountSelector();
  }
});
 })(window);